export const VIDEO_CONTENT_SRC = 'https://vimeo.com/706094337';
export const VIDEO_SRC = 'https://player.vimeo.com/video/706094337';
export const VIDEO_THUMBNAIL = '0db0b2a7275cb8da46a7746043500948-1652191438915/logo-maker-introduction-video.png';
export const TRANSLATION_TITLE_KEY = 'logo_maker_perseus.buyer_landing_page.how_to_make_logo_video.section_title';
export const PREVIEW_IMG_SIZE = {
    width: 1036,
    height: 583,
};
